import {Button, MenuItem} from '@material-ui/core';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Modal from 'Shared/components/Modal';
import OutlinedSelect from 'Shared/components/OutlinedSelect';

type SelectAgentNumberModalProps = {
  onClose: () => void;
  open: boolean;
  onChange: (agentNumber: string) => void;
  value: string;
};

const SelectAgentNumberModal = (props: SelectAgentNumberModalProps) => {
  const {onChange, onClose, open, value} = props;
  const currentAgentNumbers = useSelector((state: ReducerState) => state.user.profile.currentAgentNumbers);

  return (
    <Modal onClose={onClose} open={open} title="Select An Agent Number">
      <div className="hierarchy__container">
        <OutlinedSelect
          className="hierarchy__agent-number-select--mobile"
          label="Agent Number"
          value={value}
          onChange={e => {
            onChange(e.target.value);
          }}
        >
          {currentAgentNumbers.map(agentNumber => (
            <MenuItem key={agentNumber.value} value={agentNumber.value}>
              {agentNumber.value}
            </MenuItem>
          ))}
        </OutlinedSelect>
        <Button color="primary" variant="contained" fullWidth onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default SelectAgentNumberModal;
